export const USER_LOCALSTORAGE_KEY = "user";
export const AUTH_TOKEN_KEY = "auth_token";
export const SUPPORTED_LANG = ["ru", "en", "cn", "ar", "es", "de"];

// ---- Admin "login as user" (read-only impersonation) ------------------------
export const IMPERSONATION_BACKUP_KEY = "impersonation_admin_backup";
export const IMPERSONATION_STATE_KEY = "impersonation_state";

// Canonical set of localStorage keys that make up a login session on INT.
// Backup / restore operates on exactly this set (includes the four worker /
// server session tokens that UserProvider.logout does NOT clear).
export const SESSION_KEYS = [
    USER_LOCALSTORAGE_KEY, // "user"
    AUTH_TOKEN_KEY, // "auth_token" (mirror of personal_data token)
    "account_uid",
    "site_user_email",
    "site_user_name",
    "site_user_picture",
    "site_user_phone",
    "site_vk_id",
    "site_sber_id",
    "r2_session_token",
    "personal_data_session_token",
    "site_session_token",
    "email_id_token",
] as const;

// Per-user caches that must NOT bleed across an impersonation swap.
export const PER_USER_CACHE_LOCAL_PREFIXES = ["asked_questions_history"];
export const PER_USER_CACHE_LOCAL_EXACT = [
    "pending_purchase_links",
    "device_login_history",
];
export const PER_USER_CACHE_SESSION_PREFIXES = ["course_progress_"];
